<template>
  <div class="mb-1 border-[1px] border-[#322C3F] rounded-lg">
    <button
      class="flex items-center space-x-3 w-[100%] text-[#EFEDF2] p-[16px] cursor-pointer text-left rounded-lg"
      :aria-expanded="open"
      @click="$emit('toggle')"
      :class="{
        'bg-[#0e0d12]': !contrast,
        'bg-[#322C3F]': contrast,
        'rounded-t-lg': isFirst,
        'rounded-b-lg': isLast && !open,
      }">
      <div>
        <img src="@/assets/icons/radio_active.svg" alt="active" v-if="open" />
        <img src="@/assets/icons/radio_enabled.svg" alt="active" v-else />
      </div>
      <slot name="title" />
    </button>

    <div
      :class="{ open: open, 'rounded-b-lg': isLast }"
      class="bg-[#0e0d12] text-[#9C93B3] text-sm font-normal gap-2 rounded-lg">
      <div ref="panelContent" v-show="open" class="p-[16px] flex items-center justify-center">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap';

export default {
  props: {
    contrast: {
      type: Boolean,
      default: false,
    },
    isFirst: Boolean,
    isLast: Boolean,
    open: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.panelContent = this.$refs.panelContent;
  },
  computed: {
    isCard() {
      return this.$slots.title && this.$slots.title()[0].children === ' Pay with credit or debit card ';
    }
  },
  watch: {
    open(active) {
      if (!this.panelContent) return;

      if (active) {
        gsap.fromTo(this.panelContent, { height: this.isCard ? 275 : 50 }, { height: 'auto', duration: 0.3, ease: 'power2.out' });
      } else {
        gsap.fromTo(
          this.panelContent,
          { height: this.panelContent.scrollHeight },
          { height: 0, duration: 0.4, ease: 'power2.in' }
        );
      }
    },
  },
};
</script>
